/**
 * List Schema of ResponsavelSaraiva
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelSaraiva} from '@/model/resource/ResponsavelSaraiva'

/* TODO: review generated schema */
export class ListResponsavelSaraivaSchema extends Schema {
  readonly name = 'ListResponsavelSaraiva'

  readonly fieldSet: FieldSet<ResponsavelSaraiva> = {
    idResponsavelSaraivaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
  }
}
